module.exports = __webpack_public_path__ + "img/shopping_application_2.4e88bc28.jpg";